import {
  Collapse,
  Divider,
  Stack,
  StackProps,
  useDisclosure,
} from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { FilterHeader } from '$/components/core/Editor/ColorSelectionSidebar/Filter/FilterHeader';
import { AppliedColor } from '$/pages/InspirationEditorPage/components/AttributeSection/components/AppliedMaterial';
import { MaterialListItem } from '$/pages/InspirationEditorPage/components/AttributeSection/components/SceneDetails/components/MaterialListItem';
import { Material } from '$/services/usecases/materials';

interface Props extends StackProps {
  material: Material | null | undefined;
}

export const CurrentMaterialSection: FC<Props> = ({ material, ...props }) => {
  const { t } = useTranslation();
  const { isOpen, onToggle } = useDisclosure();

  if (material == null) return;

  return (
    <>
      <Stack w='full' {...props}>
        <FilterHeader
          header={t('inspirationEditor.attributes.usedColor')}
          isActive={isOpen}
          onClick={onToggle}
          prefix={<Icon icon='inspiration_marker' w='14px' />}
          isCollapsible
        />
        <Collapse in={isOpen}>
          <AppliedColor material={material} />
        </Collapse>
        <Collapse in={!isOpen}>
          <MaterialListItem id={1} material={material} />
        </Collapse>
      </Stack>
      <Divider />
    </>
  );
};
